var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c("div", { staticClass: "app-main-inner-row" }, [
          _c(
            "div",
            { staticClass: "triggers" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "new", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showEditDialog(true)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "edit", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showEditDialog(false)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "delete", type: "danger" },
                  on: { click: _vm.doDelete }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
              )
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              attrs: {
                no: "grid",
                "config-module": "101376",
                "grid-params": _vm.gridParams,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.gridParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.gridParams = $event
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.maintainDialog.isShow,
            "close-on-click-modal": false,
            title: _vm.maintainDialog.title,
            width: "350px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.maintainDialog, "isShow", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    model: _vm.maintainDialog.form,
                    "label-width": _vm.isZh ? "100px" : "145px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_FieldDisplay"),
                        required: ""
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "fieldDisplay",
                          "tag-value": "code",
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.maintainDialog.form.fieldDisplay,
                          "static-options":
                            _vm.SystemConstants.FIELD_DISPLAY_MODULES
                        },
                        on: { parentCallBack: _vm.fieldDisplayChangeHandle }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Field"), required: "" }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "CustomFields",
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_CustomFields$CUSTOM_FIELDS,
                          clearable: false,
                          "default-value": _vm.maintainDialog.form.fieldCode,
                          "static-options":
                            _vm.maintainDialog.form.fieldDisplay ===
                            _vm.SystemConstants.FIELD_DISPLAY_BUSINESS_MODULE
                              .code
                              ? _vm.SystemConstants.CUSTOM_FIELDS_BUSINESS
                              : _vm.SystemConstants
                                  .CUSTOM_FIELDS_PAYMENT_REQUEST
                        },
                        on: { parentCallBack: _vm.fieldChangeHandle }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.ChineseDisplayName"),
                        required: ""
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "chineseName" },
                        model: {
                          value: _vm.maintainDialog.form.chineseName,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.maintainDialog.form,
                              "chineseName",
                              $$v
                            )
                          },
                          expression: "maintainDialog.form.chineseName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.EnglishDisplayName"),
                        required: ""
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "englishName" },
                        model: {
                          value: _vm.maintainDialog.form.englishName,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.maintainDialog.form,
                              "englishName",
                              $$v
                            )
                          },
                          expression: "maintainDialog.form.englishName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ControlSelection"),
                        required: ""
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "widgetType",
                          "tag-value": "code",
                          filterable: "",
                          clearable: false,
                          disabled:
                            _vm.maintainDialog.form.fieldDisplay ===
                            _vm.SystemConstants.FIELD_DISPLAY_BUSINESS_MODULE
                              .code,
                          "default-value": _vm.maintainDialog.form.widgetType,
                          "static-options": _vm.SystemConstants.WIDGET_TYPES
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.maintainDialog.form.widgetType = p.value
                            _vm.maintainDialog.form.enumStr = ""
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.maintainDialog.form.fieldDisplay !=
                    _vm.SystemConstants.FIELD_DISPLAY_BUSINESS_MODULE.code &&
                  _vm.maintainDialog.form.widgetType ===
                    _vm.SystemConstants.WIDGET_TYPE_DROPDOWN.code
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_EnumValue"),
                            required: ""
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              disabled:
                                _vm.maintainDialog.form.fieldDisplay ===
                                _vm.SystemConstants
                                  .FIELD_DISPLAY_BUSINESS_MODULE.code,
                              rows: 3,
                              no: "enumStr"
                            },
                            model: {
                              value: _vm.maintainDialog.form.enumStr,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.maintainDialog.form,
                                  "enumStr",
                                  $$v
                                )
                              },
                              expression: "maintainDialog.form.enumStr"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "save", type: "primary" },
                  on: { click: _vm.save }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: { click: _vm.cancelSaveOrEdit }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }